import * as React from 'react';
import { FunctionComponent, useContext } from 'react';

// Custom components
import SidebarContext, {
  SidebarContextType,
} from '@/context/SidebarContext/SidebarContext';
import { Permission } from '@/@types/common';
import UserContext from '@/context/UserContext/UserContext';

// Types
export interface ISidebarPane {
  id: string;
  children: JSX.Element | JSX.Element[];
  needPermission?: Permission[];
  noPadding?: boolean; // To have more control over styling individual panes
  limitHeight?: boolean; // To disable default scrollbar over sidebar pane, useful when we want a child to be scrollable instead
  noOverflow?: boolean
}

const SidebarPane: FunctionComponent<ISidebarPane> = (
  props: React.PropsWithChildren<ISidebarPane>
) => {
  const sidebarContext = useContext(SidebarContext) as SidebarContextType;

  const { id, children, needPermission, noPadding, limitHeight, noOverflow } = props;

  const userContext = useContext(UserContext);

  const isActive = sidebarContext.activePane === id;
  return isActive && ((!needPermission || !needPermission.length) || ((needPermission && needPermission.length && (userContext?.hasAnyPermission(needPermission))))) ? (
    <div style={{overflow: noOverflow ? 'hidden' : undefined, maxHeight: limitHeight ?  "100%" : undefined, padding: noPadding ? undefined : "10px 20px"}} className="sidebar-pane active" id={id}>
      {children}
    </div>
  ) : null;
};

export default SidebarPane;
